<div class="order-not-available" [ngClass]="modalSizeClass">
  <div>
    <h1 class="order-not-available__title">{{ 'ttw.orderNotAvailableTitle' | translate }}</h1>
  </div>
  <div class="order-not-available__message">
    <h2 class="order-not-available__message__subtitle">
      {{ 'ttw.orderUnavailableMessageMain' | translate }}
    </h2>
    <h2 class="order-not-available__message__subtitle">
      {{ 'ttw.orderUnavailableMessageRetry' | translate }}
    </h2>
  </div>

  <div *ngIf="showGdprDisclaimer" class="order-not-available__disclaimer">
    <h2 class="order-not-available__disclaimer--title">
      {{ 'ttw.gdprDisclaimerTitle' | translate }}
    </h2>
    <div class="order-not-available__disclaimer__description">
      <p class="order-not-available__disclaimer__description--text">
        {{ 'ttw.gdprDisclaimerText' | translate }}
      </p>
      <qr-code
        [value]="'ttw.qrcodeUrlGDPR' | translate"
        [size]="190"
        [foreground]="'#007698'"
        [level]="'L'"
      ></qr-code>
    </div>
  </div>

  <div class="order-not-available__buttons">
    <button
      class="order-not-available__buttons__re-enter order-not-available__buttons__button"
      (click)="onReEnterCode()"
    >
      {{ 'ttw.skip' | translate }}
    </button>
    <button
      class="order-not-available__buttons__notify-me order-not-available__buttons__button"
      (click)="onNotifyMe()"
    >
      {{ 'ttw.notifyMe' | translate }}
    </button>
  </div>
</div>
